import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

// 原始的公用请求头配置
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 创建一个新的配置对象，包含 isNeed 属性
const extendedHeaderConfig = {
  headers: {
    ...jsonHeaderConfig.headers,
    isNeedAes: true // 需要加密
  }
}

// 获取布局
export const getPositionList = (data?: any) =>
  request.post('/component_data/pageAcquire', data, jsonHeaderConfig)

/**
 * @name 用户管理模块
 */
// * 获取用户列表
// export const getUserList = (params: User.ReqUserParams) => {
//   return request.post<ResPage<User.ResUserList>>('/admin/user/page', params, jsonHeaderConfig)
// }

// * 获取树形部门列表
// export const getDepartmentTree = (data?:) => {
//   return request.post<ResPage<User.ResDepartment>>('/admin/department/tree')
// }

// * 新增用户
export const addUser = (params: { id: string }) => {
  return request.post('/component_data/pageAcquire', params)
}

// 登录接口xxx
export const loginApi = (data?: Recordable) =>
  request.post('/oauth/token/web', data, extendedHeaderConfig)
// 登录接口
export const getCodeApi = (data?: Recordable, params?: Recordable) =>
  request.post('/oauth/sms', { data, params }, jsonHeaderConfig)

// 获取用户信息
export const getUserInfo = () => request.get('/admin/user/current', null)

// 获取权限菜单
export const getAuthMenuApi = (data?: Recordable) =>
  request.get('/admin/menu/current/tree', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 获取用户列表
export const getUserList = (data?: Recordable, headers: any = undefined) => {
  // let headersConfig = jsonHeaderConfig
  // if(headers){
  //   headersConfig = { headers: Object.assign(headersConfig.headers, headers) }
  // }
  return request.post(
    '/admin/user/page',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig
  )
}

// 获取树形部门列表
export const getDepartmentTree = (data?: Recordable) =>
  request.post('/admin/department/tree', data, jsonHeaderConfig)

// 新系统连登老系统
export const oldSystemLoginApi = (data?: Recordable) =>
  request.post('/crm/oldSystem/oldSystemLogin', data, jsonHeaderConfig, {
    showErrorMessage: false
  })

// 获取账户余额
export const getCoin = (data?: Recordable) => request.post('/crm/oldSystem/coin', data)

// 登出
export const logoutApi = () => request.post('/oauth/logout', null)

// 获取当前登录用户的子系统列表
export const getCurrentSystemList = () => request.get('/admin/menu/current/system', null)

// 获取当前登录用户的子系统及菜单
export const getCurrentSystemMenu = () => request.get('/admin/menu/system/tree', null)

// 获取当前登录用户的子租户列表
export const getCurrentTenantList = (mobile?: string) =>
  request.get('/admin/tenant/current', { mobile })

// 切换租户
export const switchTenant = (tenantId: any) =>
  request.post(`/oauth/tenant/switch?tenantId=${tenantId}`, { tenantId }, jsonHeaderConfig)

// 切换手机登录的租户
export const switchTenantMobile = (tenantId: any, mobile: string) =>
  request.post(
    `/oauth/tenant/switchByMobile?tenantId=${tenantId}&mobile=${mobile}`,
    { tenantId, mobile },
    jsonHeaderConfig
  )

// 新系统更新老系统用户角色
export const updateUserRoleToNewSystem = (data?: Recordable) =>
  request.post('/admin/user/updateUserRoleToNewSystem', data, jsonHeaderConfig)

// 登录指掌易
export const loginZzy = (data?: Recordable) =>
  request.post('/admin/zzy/getZzyPageUrl', data, extendedHeaderConfig)

// 登录融掌通
export const loginMdm = (data?: Recordable) => request.post('/admin/mdm/getToken', data)

// 修改ui版本
export const updateUiVersion = (data?: Recordable) =>
  request.post('/admin/user/updateUiVersion', data, jsonHeaderConfig)
// 新增用户指引
export const addUserGuide = (data?: Recordable) =>
  request.post('/admin/userGuidance/add', data, jsonHeaderConfig)

// 是否存在用户指引
export const checkUserGuide = (data?: Recordable) =>
  request.post('/admin/userGuidance/get', data, jsonHeaderConfig)
